import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { authAPI } from '../../services/api';
import { Building2 } from 'lucide-react';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone.trim()) {
      toast.error('Please enter your phone number');
      return;
    }

    setLoading(true);
    try {
      await authAPI.forgotPassword(phone.trim());
      toast.success('If the phone is registered, an OTP has been sent to that number.');
      navigate(`/setup-password?phone=${encodeURIComponent(phone.trim())}`);
    } catch (err) {
      const msg = err?.response?.data?.message || 'Failed to request password reset';
      toast.error(Array.isArray(msg) ? msg[0] : msg);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className='h-full flex flex-col items-center justify-center p-8 animate-slide-up'>
           <div className='text-center mb-12'>
                  <div className='w-24 h-24 bg-gradient-to-br from-[#FFC107] to-[#FF9800] rounded-3xl flex items-center justify-center mb-8 mx-auto'>
                    <Building2 className='w-12 h-12 text-white' />
                  </div>
                  <h1 className='text-4xl font-black italic mb-2 tracking-tighter text-white uppercase'>cssRMS</h1>
                  <p className='text-[#FFC107] text-sm font-bold uppercase tracking-[0.3em] mb-2'>Revenue Management System</p>
                  <p className='text-xs text-white/40'>Harvard RMetaverse Project</p>
                </div>
          
      <div className='w-full max-w-md'>
        <button
          type='button'
          onClick={() => navigate('/')}
          className='text-xs text-white/60 hover:text-white/90 underline mb-4'>
          Back to login
        </button>

        <h1 className='text-2xl font-black text-white mb-2 uppercase'>Forgot Password</h1>
        <p className='text-sm text-white/60 mb-6'>Enter your registered phone number to receive an OTP.</p>

        <form onSubmit={handleSubmit} className='space-y-4'>
          <div>
            <label className='block text-xs font-bold uppercase text-white/60 mb-2'>Phone Number</label>
            <PhoneInput
              international
              defaultCountry='GH'
              value={phone}
              onChange={setPhone}
  className='phone-input-dark'
              placeholder='+233 20 123 4567'
            />
            <p className='text-xs text-white/40 mt-1'>Phone number will include country code automatically.</p>
          </div>

          <button
            type='submit'
            disabled={loading || !isValidPhoneNumber(phone || '')}
            className='w-full py-4 rounded-2xl btn-gold font-black uppercase text-sm disabled:opacity-50'>
            {loading ? 'Requesting...' : 'Send reset OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
